"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _image = _interopRequireDefault(require("../image"));
var mapTypes = function mapTypes(typesSlice) {
  if (!typesSlice || typesSlice.length === 0) return false;
  var types = [];
  typesSlice.map(function (typeSlice) {
    typeSlice.items.map(function (tile) {
      var _tile$url;
      types.push({
        name: tile.title && tile.title[0].text,
        url: (_tile$url = tile.url) !== null && _tile$url !== void 0 && _tile$url.url ? tile.url.url.replace("https:/", "") : "/",
        image: (0, _image["default"])(tile.image)
      });
    });
  });
  return types;
};
var _default = mapTypes;
exports["default"] = _default;